<template>
  <div>
    <v-data-table :headers="headers" :items="licitacionParticipantes">
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="item.createdAt"> </fecha-humano>
      </template>
      <template v-slot:[`item.asistio`]="{ item }">
        <asistio-switch
        v-if="mixValidaScopesActions(2)"
        :participanteVisitaObra="item"></asistio-switch>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import FechaHumano from '@/components/FechaHumano.vue';
import AsistioSwitch from '@/components/administracion/licitaciones/visitaobra/Asistio.vue';

export default {
  name: 'ListadoVisitaObraLicitacionDesktop',
  components: {
    FechaHumano,
    AsistioSwitch,
  },
  data() {
    return {
      headers: [
        // {
        //   text: 'RFC',
        //   align: 'start',
        //   width: '200',
        //   sortable: false,
        //   value: 'contratista.rfc',
        // },
        { text: 'Razón Social', value: 'contratista.nombreRazonSocial' },
        // { text: 'Correo Electrónico', value: 'contratista.correoElectronico' },
        // { text: 'Fecha de Registro', value: 'createdAt' },
        { text: 'Asistió?', value: 'asistio' },
      ],
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
};
</script>

<style lang="scss">
</style>
